import React from 'react';
import styled from '@emotion/styled';
import { useSpringCarouselContext } from '../../hooks';
const StyledNavigationThumb = styled.button `
  border: none;
  border-radius: 0;
  bottom: 0;
  cursor: pointer;
  flex-grow: 1;
  font-size: 12px;
  height: 39px;
  width: 100%;
  line-height: 15px;
  margin: 0;
  padding: 0 10px;
  position: relative;
  text-align: left;
  text-indent: 0;
  transition: bottom 0.2s;
  white-space: normal;
  background: ${({ theme }) => theme.colors.backgrounds.primaryNavigation.background};
  color: ${({ theme }) => theme.colors.backgrounds.primaryNavigation.text[1]};

  ${({ active, theme }) => active &&
    `
        border-top: 1px solid ${theme.colors.interactions.oddsConcession.border.default};
        color: ${theme.colors.backgrounds.primaryNavigation.text[0]};
        font-size: 12px;
        font-weight: ${theme.fontWeights.bold};
        height: 100%;
    `}
`;
const NavigationThumb = ({ id, itemId, children, onClick, }) => {
    const { getIsActiveItem } = useSpringCarouselContext();
    const isActive = getIsActiveItem(itemId);
    return (React.createElement(StyledNavigationThumb, { id: id, active: isActive, onClick: onClick, role: "tab", "aria-selected": isActive, tabIndex: isActive ? -1 : 0 }, children));
};
export default NavigationThumb;
